<template>
  <div id="updPassword">
    <div class="top">
      <i class="iconfont icon-zhaohuimima1"></i>
    </div>
    <div class="form">
      <input type="text" placeholder="请输入手机号" v-model="phone">
      <input type="text" class="yzm am-fl" placeholder="验证码" v-model="yzm">
      <button class="yzm am-fr" :class="{ disable: this.btnyzm !== '获取验证码'}" @click="sendCode()">{{btnyzm}}</button>
      <input type="password" class="" placeholder="请输入新密码" v-model="password1">
      <input type="password" class="" placeholder="再次输入新密码" v-model="password2">
      <button style="margin-top: -5px" @click="submit()">重置</button>
      <p>放弃找回，<span><router-link class="first" :to="{name: 'zcgl', params: {nr: 'login'}}">返回登录页面</router-link></span>
      </p>
    </div>
    <alert :showModal.sync="showAlert">{{alertMessage}}</alert>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  import alert from '@/components/alert/alert'
  import md5 from 'js-md5'
  import router from '@/router'

  export default {
    name: 'updPassword',
    data () {
      return {
        wait: 60,
        btnyzm: '获取验证码',
        yzm: '',
        phone: '',
        password1: '',
        password2: '',
        alertMessage: '',
        showAlert: false
      }
    },
    components: {alert},
    methods: {
      submit: function () {
        if (!this.password1) {
          this.alertMessage = '新密码为空'
          this.showAlert = true
          return
        }
        if (this.password1 !== this.password2) {
          this.alertMessage = '两次密码不同'
          this.showAlert = true
          return
        }
        let senddata = {
          yzm: this.yzm,
          phone: $.trim(this.phone),
          password: md5(this.password1)
        }
        ajax.updPassword(senddata).then(
          () => {
            this.alertMessage = '重置成功'
            this.showAlert = true
            this.$watch('showAlert', function () {
              router.push({name: 'zcgl', params: {nr: 'login'}})
            })
          })
      },
      sendCode: function () {
        if (this.btnyzm !== '获取验证码') {
          this.alertMessage = '验证码请求太快请稍等'
          this.showAlert = true
          return
        }
        let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/
        if (!myreg.test($.trim(this.phone))) {
          this.alertMessage = '手机号有误'
          this.showAlert = true
          return
        }
        let senddata = {
          phone: $.trim(this.phone),
          iszh: true
        }

        ajax.sendCode(senddata).then(
          () => {
            let vm = this

            function time () {
              if (vm.wait === 0) {
                vm.btnyzm = '获取验证码'
                vm.wait = 60
              } else {
                vm.btnyzm = vm.wait + '秒后重新发送'
                vm.wait--
                setTimeout(function () {
                  time()
                }, 1000)
              }
            }

            time()
          })
      }
    },
    created: function () {
      this.$emit('update:titlestr', '找回密码')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// updPassword.vue?4420d24a